<template>
	<div>
		<div class="supervisorRank" v-loading="hospitalRankLoading">
			<div class="rankTop" ref="breadcrumbs">
				<div class="rankTopLeft">
					<svg-icon class="fz18 marr4" icon-class="icon-region"></svg-icon>
					<span class="marr4">{{ HospitalAVGScoreName.makeUp }}</span>
					<span @click="doctorSwipt">
						<svg-icon class="fz18 marr4 cur" icon-class="icon-sort"></svg-icon>
					</span>
				</div>
				<template v-if="HospitalAVGScore.length > 0 && !trigger.regionsData">
					<div class="cur" @click="handleChange">
						<div class="averageScore" v-if="HospitalAVGScoreBtn.average">
							<span>
								最高平均分：
								<b class="averageScoreOrganizationUp">{{ HospitalAVGScores.Max.AvgScore }}</b>
								分({{ HospitalAVGScores.Max.HospitalName }})
							</span>
							<span class="marr15">
								最低平均分:
								<b class="averageScoreOrganizationDown">{{ HospitalAVGScores.Min.AvgScore }}</b>
								分({{ HospitalAVGScores.Min.HospitalName }})
							</span>
							<i
								:class="isShowEcharts.hospital ? 'el-icon-caret-bottom' : 'el-icon-caret-bottom trs180'"></i>
						</div>
					</div>
				</template>
			</div>
			<el-collapse v-model="isShowEcharts.hospital ? activeNames : '2'"
				:class="isShowEcharts.hospital ? 'mart10' : ''" @change="handleChange">
				<el-collapse-item name="1" v-loading="loading">
					<template slot="title"></template>
					<div v-if="HospitalAVGScore.length > 0" ref="container">
						<div class="echarts">
							<div id="container"></div>
						</div>
					</div>
					<div v-else class="echartsNull">
						<div>
							<svg-icon class="fz18 marr4" icon-class="icon-default-Nodata"></svg-icon>
						</div>
						<div class="text">暂无数据</div>
					</div>
				</el-collapse-item>
			</el-collapse>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex';
	import echarts from 'echarts';
	export default {
		data() {
			return {
				barHeight: 0,
				activeNames: '1',
				myChart: null,
				height: 25,
				barMaxWidth: 7,
				selectedId: ''
			};
		},
		computed: {
			...Vuex.mapState('breadcrumb', ['skinPeeler', 'isTree', 'breadLists', 'commonpars']),
			...Vuex.mapState('centralStatistics', ['hospitalResultParameter', 'resultTabs', 'reportDate']),
			...Vuex.mapState('supervisor', [
				'QualifiedPart',
				'breadcrumbList',
				'slider',
				'GetReportListArr',
				'hospitalRankLoading',
				'regionType',
				'loading',
				'InstitutionalRanking',
				'HospitalAVGScore',
				'trigger',
				'HospitalAVGScores',
				'HospitalAVGScoreBtn',
				'HospitalAVGScoreArr',
				'DoctorsAvgScoreArr',
				'treeDefault',
				'HospitalAVGScoreName',
				'isShowEcharts',
				'HospitalAVGTypeName',
				'DoctorsAvgScoreName',
				'setDateArr'
			])
		},
		watch: {
			skinPeeler: {
				handler(newValue, oldValue) {
					this.init();
				},
				deep: true
			}
		},
		activated() {
			this.isShowEcharts.hospital = true;
			this.init();
		},
		mounted() {
			this.init();
		},
		updated() {
			if (this.trigger.hospital) {
				this.trigger.hospital = false;
				if (this.HospitalAVGScore.length > 0) {
					this.getEcharts();
				}
			}
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['changeisTree','setTootipType', 'clearRow']),
			...Vuex.mapMutations('centralStatistics', ['changeType']),
			...Vuex.mapMutations('supervisor', ['currentChangesSecond', 'zoneBtnChange', 'settableLoading','setLoading','setBreadcrumbList']),
			...Vuex.mapActions('supervisor', [
				'GetHospitalAVGScore',
				'GetHospitalUnqualifiedReport',
				'GetDoctorsAvgScore',
				'GetDoctorUnqualifiedReport',
				'GetReportList',
				'GetRegionAVGScore',
				'GetSummary',
				'GetCount'
			]),
			...Vuex.mapActions('centralStatistics', ['GetHospitalResult']),
			init() {
				//左侧导航收起时右侧图联动
				let _this = this;
				this.erd.listenTo(document.getElementsByClassName('el-main'), function(element) {
					if (_this.myChart) {
						let dom = document.getElementById('container');
						if (dom) {
							dom.style.width = _this.$refs.container.offsetWidth - 40 + 'px';
							_this.myChart.resize();
							_this.getEcharts();
						}
					}
				});
			},
			doctorSwipt() {
				this.InstitutionalRanking.type = 1;
				let sortType = this.HospitalAVGScoreArr.sortType == 2 ? 1 : 2;
				this.HospitalAVGScoreArr.sortType = sortType;
				if (this.HospitalAVGScoreBtn.average) {
					this.GetHospitalAVGScore();
				}
				if (this.HospitalAVGScoreBtn.deduct) {
					this.GetHospitalUnqualifiedReport();
				}
			},
			// 调用的接口
			callFun() {
				this.GetSummary();
				this.GetCount();
				this.getEcharts();
			},
			defaultGet() {
				this.settableLoading(true);
				this.DoctorsAvgScoreArr.pageIndex = 1;
				if (this.HospitalAVGScoreBtn.average) {
					this.GetDoctorsAvgScore();

				}
				if (this.HospitalAVGScoreBtn.deduct) {
					this.GetDoctorUnqualifiedReport();
				}
				this.callFun()
			},
			defaultDoctorGet() {
				this.DoctorsAvgScoreArr.pageIndex = 1;
				if (this.HospitalAVGScoreBtn.average) {
					this.GetDoctorsAvgScore();
				}
				if (this.HospitalAVGScoreBtn.deduct) {
					this.GetDoctorUnqualifiedReport();
				}
			},
			handleChange() {
				this.isShowEcharts.hospital = !this.isShowEcharts.hospital;
			},
			makeUp() {
				this.HospitalAVGScoreName.makeUp = this.HospitalAVGScoreName.name + this.HospitalAVGScoreName.region + this
					.HospitalAVGScoreName.condition + this.HospitalAVGScoreName.rank;
				this.DoctorsAvgScoreName.makeUp = this.DoctorsAvgScoreName.name + this.DoctorsAvgScoreName.type + this
					.DoctorsAvgScoreName.condition + this.DoctorsAvgScoreName.rank;
			},
			getEcharts() {
				let _this = this;
				let changeColor = this.skinPeeler.status ? '#ffffff' : '#333333';
				let dom = document.getElementById('container');
				dom.style.width = this.$refs.breadcrumbs.offsetWidth + 'px';
				this.height = document.body.clientWidth >= 1440 ? 50 : 35;
				this.barMaxWidth = document.body.clientWidth >= 1440 ? 10 : 7;
				this.myChart = echarts.init(dom);
				let data = [];
				let value = [];
				let ranking = [];
				let color = ['#248AFD'];
				if (this.HospitalAVGScore.length > 0) {
					//选中平均分
					if (this.HospitalAVGScoreBtn.average) {
						color = ['#248AFD'];
						if (this.trigger.regionsData) {
							this.HospitalAVGScore.forEach(element => {
								if (element.RegionGuid == this.treeDefault.checked) {
									data.unshift({
										value: element.RegionName,
										RegionType: element.RegionType,
										RegionGuid: element.RegionGuid,
										HospitalGuid: element.HospitalGuid,
										textStyle: {
											color: color,
											fontSize: 12
										}
									});
								} else {
									data.unshift({
										value: element.RegionName,
										RegionType: element.RegionType,
										RegionGuid: element.RegionGuid,
										HospitalGuid: element.HospitalGuid,
									});
								}

								value.unshift({
									value: element.AvgScore,
									sampledNum: element.SampledNum,
									RegionType: element.RegionType,
									RegionGuid: element.RegionGuid,
									HospitalGuid: element.HospitalGuid,
								});
								ranking.unshift({
									value: '第' + element.TotalRank + '名',
									textStyle: {
										color: changeColor,
										fontSize: 12
									}
								});
							});
						} else {
							this.HospitalAVGScore.forEach(element => {
								if (element.HospitalGuid == this.treeDefault.checked) {
									data.unshift({
										value: element.HospitalName,
										RegionType: element.RegionType,
										RegionGuid: element.RegionGuid,
										HospitalGuid: element.HospitalGuid,
										textStyle: {
											color: color,
											fontSize: 12
										}
									});
								} else {
									data.unshift({
										value: element.HospitalName,
										RegionType: element.RegionType,
										RegionGuid: element.RegionGuid,
										HospitalGuid: element.HospitalGuid,
									});
								}

								value.unshift({
									value: element.AvgScore,
									sampledNum: element.SampledNum,
									RegionType: element.RegionType,
									RegionGuid: element.RegionGuid,
									HospitalGuid: element.HospitalGuid,
								});
								ranking.unshift({
									value: '第' + element.TotalRank + '名',
									textStyle: {
										color: changeColor,
										fontSize: 12
									}
								});
							});
						}
					}
					//选中不合格报告
					if (this.HospitalAVGScoreBtn.deduct) {
						color = ['#2EB4B5'];
						if (this.trigger.regionsData) {
							this.HospitalAVGScore.forEach(element => {
								if (element.RegionGuid == this.treeDefault.checked) {
									data.unshift({
										value: element.RegionName,
										RegionType: element.RegionType,
										RegionGuid: element.RegionGuid,
										HospitalGuid: element.HospitalGuid,
										textStyle: {
											color: color,
											fontSize: 12
										}
									});
								} else {
									data.unshift({
										value: element.RegionName,
										RegionType: element.RegionType,
										RegionGuid: element.RegionGuid,
										HospitalGuid: element.HospitalGuid,
									});
								}

								value.unshift({
									value: element.ReportCount,
									sampledNum: element.SampledNum,
									RegionType: element.RegionType,
									RegionGuid: element.RegionGuid,
									HospitalGuid: element.HospitalGuid,
								});
							});
						} else {
							this.HospitalAVGScore.forEach(element => {
								if (element.HospitalGuid == this.treeDefault.checked) {
									data.unshift({
										value: element.HospitalName,
										RegionType: element.RegionType,
										RegionGuid: element.RegionGuid,
										HospitalGuid: element.HospitalGuid,
										textStyle: {
											color: color,
											fontSize: 12
										}
									});
								} else {
									data.unshift({
										value: element.HospitalName,
										RegionType: element.RegionType,
										RegionGuid: element.RegionGuid,
										HospitalGuid: element.HospitalGuid,
									});
								}

								value.unshift({
									value: element.ReportCount,
									sampledNum: element.SampledNum,
									RegionType: element.RegionType,
									RegionGuid: element.RegionGuid,
									HospitalGuid: element.HospitalGuid,
								});
							});
						}
					}
				} else {
					data = [];
					value = [];
				}
				let app = {};
				let option = null;

				option = {
					color: color,
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'none'
						},
						formatter: function(params, ticket, callback) {
							return `总抽样报告数: ${params[0].data.sampledNum}份`;
						}
					},
					grid: {
						top: 0,
						left: '6%',
						right: '6%',
						bottom: '0%',
						containLabel: true
					},
					xAxis: {
						type: 'value',
						axisTick: {
							show: false
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#464E57'
							}
						},
						axisLabel: {
							textStyle: {
								color: changeColor
							}
						},
						splitLine: {
							show: false
						}
					},
					yAxis: [{
							type: 'category',
							data: data,
							triggerEvent: true,
							axisTick: {
								show: false
							},
							axisLine: {
								show: false,
								lineStyle: {
									color: changeColor
								}
							},
							axisLabel: {
								textStyle: {
									color: changeColor,
									fontSize: 12
								}
							},
							splitLine: {
								show: false
							}
						},
						{
							type: 'category',
							position: 'left',
							offset: 90,
							name: '排名',
							data: ranking,
							triggerEvent: true,
							axisTick: {
								show: false
							},
							axisLine: {
								show: false,
								lineStyle: {
									color: changeColor
								}
							},
							axisLabel: {
								textStyle: {
									color: changeColor,
									fontSize: 12
								}
							},
							splitLine: {
								show: false
							}
						}
					],
					series: [{
						barMaxWidth: this.barMaxWidth,
						name: '影像中心',
						type: 'bar',
						barCategoryGap: 2,
						label: {
							show: true,
							color: changeColor,
							position: 'right',
							formatter: this.HospitalAVGScoreBtn.deduct?'{c}份':'{c}分'
						},
						itemStyle: {
							barBorderRadius: [10, 10, 10, 10]
						},
						data: value
					}]
				};
				if (this.HospitalAVGScoreBtn.average) {
					option.xAxis.max = 100;
					option.xAxis.interval = 20;
				}
				if (option && typeof option === 'object') {
					this.myChart.clear();
					this.myChart.setOption(option, true);
					this.myChart.off('click'); //清除联系点击
					this.myChart.on('click', params => {
						if (this.HospitalAVGScoreBtn.average && !this.trigger.regionsData) {
							this.changeisTree(false);
							this.changeType(true);
							this.commonpars.name = params.name;
							this.hospitalResultParameter.hospitalGuid = params.data.HospitalGuid;
							if (this.HospitalAVGScoreArr.type == 2 || this.HospitalAVGScoreArr.type == 4) {
								this.hospitalResultParameter.type = 2;
							} else if (this.HospitalAVGScoreArr.type == 3) {
								this.hospitalResultParameter.type = 1;
							}
							// 审核2，首诊4，技师3
							this.hospitalResultParameter.doctorType = this.HospitalAVGScoreArr.type;
							// 跳转 centralStatistics 清空时间参数
							this.reportDate.data = []
							this.$router.push(`/home/supervisor/centralStatistics`);
						} 
						if(this.HospitalAVGScoreBtn.deduct){
							this.setLoading(true);
							this.settableLoading(true);
							this.setTootipType(false);
							this.clearRow();
							this.currentChangesSecond(1);
							this.QualifiedPart.hospitalGuid = params.data.HospitalGuid;
							this.QualifiedPart.type = 'unqualified';
							this.setBreadcrumbList();
							this.GetReportListArr.type = "不合格报告列表";
							this.GetReportListArr.name = '';
							this.breadcrumbList.push(this.setDateArr.data[0] + '-' + this.setDateArr.data[1]);
							this.$router.push("/home/supervisor/qualifiedTable");
							this.breadcrumbList.push(params.name+"不合格");
						}
					});
					this.barHeight = data.length * this.height;
					dom.style.height = this.barHeight + 'px';
					this.myChart.resize(); //区域更新
					window.addEventListener('resize', () => {
						this.myChart.resize();
					});
				}
			},
			setPoints(hospitalGuid, doctorName) {
				if (this.HospitalAVGScoreBtn.deduct) {
					//显示右侧不合格列表
					this.GetReportList({
						hospitalGuid: hospitalGuid,
						doctorName: doctorName,
						isUnqualified: true
					});
				}
			}
		}
	};
</script>

<style scoped>
	#echarts {
		width: 95%;
		height: 400px;
		margin: 0 auto;
	}
</style>
